import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// These are font sizes, not text colors. Without this, adding a color removes
// the CMS size and headings fall back to the app's oversized base styles.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: ['cms-title', 'cms-card', 'cms-body', 'cms-meta', 'cms-eyebrow', 'cms-control', 'cms-control-sm', 'cms-numeral'] }],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** Reveal a tab inside its strip without scrolling any ancestor vertically. */
export function revealHorizontalTab(container: HTMLElement | null) {
    const active = container?.querySelector<HTMLElement>('[data-active="true"]');
    if (!container || !active) return;
    const strip = container.getBoundingClientRect();
    const tab = active.getBoundingClientRect();
    const left = strip.left + container.clientLeft;
    const right = left + container.clientWidth;
    if (tab.left < left) container.scrollLeft += tab.left - left;
    else if (tab.right > right) container.scrollLeft += tab.right - right;
}

/**
 * Convert a snake_case or kebab-case string to human-readable format
 * Examples:
 * - "page_metadata" => "Page Metadata"
 * - "page-metadata" => "Page Metadata"
 * - "agents" => "Agents"
 */
export function toHumanReadable(str: string): string {
    if (!str || typeof str !== 'string') {
        console.warn('[toHumanReadable] Invalid input:', str);
        return '';
    }
    return str
        .split(/[-_]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
